import React from 'react';
import { Spinner as BootstrapSpinner } from 'react-bootstrap';

const Spinner = ({ 
    animation = 'border', 
    variant = 'primary', 
    size, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    children,
    ...props 
}) => {
    return (
        <BootstrapSpinner 
            animation={animation} 
            variant={variant} 
            size={size}
            className={className} 
            style={style}
            {...props}
        >
            {children && <span className="visually-hidden">{children}</span>}
        </BootstrapSpinner>
    );
};

export default Spinner;

